module.exports = __webpack_public_path__ + "static/media/door0104.093aef15.jpg";